<template>
  <div class="subscription-container" :style="styles">
    <!-- Enter phone number -->
    <div v-if="uiState == UnsubUIState.InputPhoneNumber" class="input-box-container">
      <h3>{{ $t('landing.enterPhoneNumberForUnsubscribe') }}</h3>

      <div class="input-box">
        <div id="phone" ref="cellNumberWrapper" class="input_container animated">
          <div class="input-prepend">
            <svg
              id="Capa_1"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="35px"
              height="35px"
              viewBox="0 0 35 35"
              style="enable-background:new 0 0 35 35;"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M25.302,0H9.698c-1.3,0-2.364,1.063-2.364,2.364v30.271C7.334,33.936,8.398,35,9.698,35h15.604
		                    c1.3,0,2.364-1.062,2.364-2.364V2.364C27.666,1.063,26.602,0,25.302,0z M15.004,1.704h4.992c0.158,0,0.286,0.128,0.286,0.287
		                    c0,0.158-0.128,0.286-0.286,0.286h-4.992c-0.158,0-0.286-0.128-0.286-0.286C14.718,1.832,14.846,1.704,15.004,1.704z M17.5,33.818
		                    c-0.653,0-1.182-0.529-1.182-1.183s0.529-1.182,1.182-1.182s1.182,0.528,1.182,1.182S18.153,33.818,17.5,33.818z M26.021,30.625
		                    H8.979V3.749h17.042V30.625z"
                />
              </g>
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
            </svg>
          </div>
          <input
            ref="cellNo"
            v-model="phoneNumber"
            placeholder="09121234567"
            pattern="[0-9]"
            name="phoneNumber"
            type="tel"
            maxlength="12"
            @input="checkLength"
          >
        </div>
        <p v-show="showPhoneNumberError" class="alert">
          {{ $t('security.phoneNumberIsInvalid') }}
        </p>
      </div>

      <button
        ref="register"
        class="button register"
        :class="configurations.unsubButtonType + ' ' + configurations.unsubButtonAccent"
        @click="unsub"
      >
        <span>{{ configurations.unsubButtonText }}</span>
      </button>
    </div>

    <!-- Unsub confirmed -->
    <div
      v-if="uiState == UnsubUIState.Confirmed"
      class="result-box-confirmed success messageBox slideTop"
    >
      <span>{{ $t('landing.unsubscribedSuccessfully') }}</span>
    </div>

    <!-- Unsub failed -->
    <div v-if="uiState == UnsubUIState.Failed" class="result-box-failed alert messageBox slideTop">
      <span>{{ $t('landing.unsubscriptionFailed') }}</span>
      <br>
      <span>{{ $t(errorMessage) }}</span>
    </div>

    <div
      v-if="uiState == UnsubUIState.SendingInitRequest || uiState == UnsubUIState.WaitingForInitStatus"
      class="loadingWrapper"
    >
      <div class="preloader loading">
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
      </div>

      <!-- Sending API Request -->
      <h3
        v-if="uiState == UnsubUIState.SendingInitRequest"
        class="sending-request-box loadingMessage"
      >
        <span>{{ $t('landing.sendingRequest') }}</span>
      </h3>

      <!-- Waiting for Processing -->
      <h3 v-if="uiState == UnsubUIState.WaitingForInitStatus" class="waiting-box loadingMessage">
        <pre>{{ $t('landing.waitingForProcessing') }}</pre>
        <span>{{ $t('landing.status') }}</span>
        <span>{{ getStatusText }}</span>
      </h3>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

export default Vue.extend({
  name: 'SectionUnsub',
  props: {
    configurations: Object,
    styles: String,
    pageInfo: Object
  },
  data () {
    return {
      phoneNumber: '',
      requestStatus: SubscriptionStatusTypes.Initialize,
      uiState: UnsubUIState.InputPhoneNumber,
      UnsubUIState: UnsubUIState,
      showPhoneNumberError: false,
      errorMessage: ''
    }
  },
  methods: {
    ...mapActions({
      initUnsub: 'subscription/initUnsub',
      getUnsubStatus: 'subscription/getUnsubStatus',
      trackLandingEvent: 'landingPage/trackEvent',
      getUnsubUrl: 'consentPage/getUnsubUrl'
    }),
    checkLength: function () {
      this.showPhoneNumberError = false

      let button = this.$refs.register
      var element = this.$refs.cellNo
      var length = element.value.length
      let buttonColor = button.classList.contains('green')
        ? '153, 204, 102'
        : '82, 170, 204'
      button.style =
        'background: rgba(' +
        buttonColor +
        ',' +
        (length + 2) / 10 +
        '); border: inset 5px rgba(255, 255, 255,' +
        (length + 2) / 10 +
        ')'

      if (length > 10) {
        button.classList.add('shadow')
      } else {
        button.classList.remove('shadow')
      }
    },
    unsub: function () {
      // TODO: Validate phone number
      let element = this.$refs.cellNo
      let length = element.value.length

      if (length < 10) {
        // Phone number is invalid
        this.showPhoneNumberError = true

        let inputWrapper = this.$refs.cellNumberWrapper
        inputWrapper.classList.add('tada')
        setTimeout(() => {
          inputWrapper.classList.remove('tada')
        }, 1000)
      } else {
        this.showPhoneNumberError = false

        if (this.pageInfo.subscriptionMethodId === 'rgk') {
          this.processConsentPageUnsubInit()
        } else {
          this.sendUnsubRequest()
        }

        // TODO: for dev only
        // this.uiState = UnsubUIState.SendingInitRequest;
        // setTimeout(() => {
        //   this.uiState = UnsubUIState.WaitingForInitStatus;
        // }, 3000);
        // setTimeout(() => {
        //   this.uiState = UnsubUIState.Confirmed;
        // }, 9000);
      }
    },
    sendUnsubRequest: function () {
      let self = this
      self.uiState = UnsubUIState.SendingInitRequest

      let input = {
        refCode: this.refCode,
        userUniqueIdentifier: this.phoneNumber,
        serviceId: this.pageInfo.serviceId,
        subscriptionMethodId: this.pageInfo.subscriptionMethodId
      }
      this.initUnsub(input)
        .then(result => {
          this.trackEvent(
            LandingPageSessionEventType.SendingUnsubRequestSucceeded
          )
          self.uiState = UnsubUIState.WaitingForInitStatus
          this.checkInitStatus()
        })
        .catch(response => {
          let error = response.body.error
          this.trackEvent(LandingPageSessionEventType.SendingUnsubRequestFailed)
          if (error && error.message) {
            this.errorMessage = 'landing.' + error.message.replace(' ', '')
          } else {
            this.errorMessage = ''
          }
          self.uiState = UnsubUIState.Failed
        })
    },
    checkInitStatus: function () {
      let self = this

      setTimeout(() => {
        this.getUnsubStatus(this.refCode)
          .then(response => {
            let result = response.body.result
            self.requestStatus = result.state

            switch (result.state) {
              case SubscriptionStatusTypes.Initialize:
              case SubscriptionStatusTypes.Processing:
                self.checkInitStatus()
                break
              case SubscriptionStatusTypes.Failed:
                this.trackEvent(
                  LandingPageSessionEventType.UnsubscriptionFailed
                )
                self.uiState = UnsubUIState.Failed
                break
              case SubscriptionStatusTypes.AwaitingConfirm:
                break
              case SubscriptionStatusTypes.Confirm:
                this.trackEvent(
                  LandingPageSessionEventType.UnsubscriptionSucceeded
                )
                self.uiState = UnsubUIState.Confirmed
                setTimeout(() => {
                  window.location.href =
                    this.pageInfo.redirectUrl +
                    '?userUniqueIdentifier=' +
                    this.phoneNumber
                }, 1000)
                break
            }
          })
          .catch(error => {
            self.checkInitStatus()
          })
      }, 1000)
    },
    trackEvent: function (eventType) {
      let input = {
        refCode: this.refCode,
        pageId: this.pageInfo.id,
        eventType: eventType
      }
      this.trackLandingEvent(input).then(result => {
        // Do nothing
      })
    },
    processConsentPageUnsubInit: function () {
      let input = {
        subscriptionMethodId: this.pageInfo.subscriptionMethodId,
        gatewayPageCode: this.pageInfo.gatewayPageCode,
        refCode: this.refCode,
        userUniqeIdentifier: this.phoneNumber,
        callBackUrl:
          window.location.href + '/' + this.phoneNumber + '/' + this.refCode
      }
      this.getUnsubUrl(input).then(consentResult => {
        setTimeout(() => {
          window.location.href = consentResult.url
        }, 5000)
      })
    }
  },
  computed: {
    ...mapGetters({
      refCode: 'landingPage/refCode'
    }),
    getStatusText: function () {
      switch (this.requestStatus) {
        case SubscriptionStatusTypes.Initialize:
          return this.$t('landing.waitingForProcessingUnsubscribeRequest')
        case SubscriptionStatusTypes.Processing:
          return this.$t('landing.processingUnsubscribeRequest')
        case SubscriptionStatusTypes.AwaitingConfirm:
        case SubscriptionStatusTypes.ConfirmInit:
        case SubscriptionStatusTypes.ConfirmProcessing:
          // These statuses are not used
          return ''
        case SubscriptionStatusTypes.Confirm:
          return this.$t('landing.unsubscribeSucceeded')
        case SubscriptionStatusTypes.Failed:
          return this.$t('landing.unsubscibeFailed')
      }
    }
  }
})

export const SubscriptionStatusTypes = {
  Initialize: 'Initialize',
  Processing: 'Processing',
  AwaitingConfirm: 'AwaitingConfirm',
  ConfirmInit: 'ConfirmInit',
  ConfirmProcessing: 'ConfirmProcessing',
  Confirm: 'Confirm',
  Failed: 'Failed'
}
export const UnsubUIState = {
  InputPhoneNumber: 1,
  SendingInitRequest: 2,
  WaitingForInitStatus: 3,
  Confirmed: 7,
  Failed: 8
}
export const LandingPageSessionEventType = {
  PageVisited: 1,

  SendingSubRequestSucceeded: 101,
  SendingSubRequestFailed: 102,
  SubRequestFailedBeforeConfirm: 103,
  ConfirmationCodeSent: 104,
  SendingConfirmRequestSucceeded: 105,
  SendingConfirmRequestFailed: 106,
  InvalidConfirmationCode: 107,
  SubscriptionSucceeded: 108,
  SubscriptionFailed: 109,

  SendingUnsubRequestSucceeded: 111,
  SendingUnsubRequestFailed: 112,
  UnsubscriptionSucceeded: 113,
  UnsubscriptionFailed: 114
}
</script>
